import fabric from '@/pages/customize/utils/newFabric';

// 用于将图片的points 点位, 变成一个平滑的曲线来进行相连,这样刀线就没有那么生硬
class DrawUtilFunc {
  public currentCanvas: any;
  constructor(canvasIns) {
    this.currentCanvas = canvasIns;
  }
  createSmoothCurvePoints(points, tension, closed, numberOfSegments) {
    if (points.length < 40) {
      return points;
    }
    tension = tension ? tension : 0.5;
    closed = closed ? true : false;
    numberOfSegments = numberOfSegments ? numberOfSegments : 16;

    var ps = points.slice(0), // clone array so we don't change the original
      result = [], // result points
      x,
      y, // our x,y coords
      t1x,
      t2x,
      t1y,
      t2y, // tension vectors
      c1,
      c2,
      c3,
      c4, // cardinal points
      st,
      t,
      i; // steps based on number of segments
    if (closed) {
      ps.unshift(points[points.length - 1]);
      ps.unshift(points[points.length - 2]);
      ps.unshift(points[points.length - 1]);
      ps.unshift(points[points.length - 2]);
      ps.push(points[0]);
      ps.push(points[1]);
    } else {
      ps.unshift(points[1]); // copy 1st point and insert at beginning
      ps.unshift(points[0]);
      ps.push(points[points.length - 2]); // copy last point and append
      ps.push(points[points.length - 1]);
    }
    for (i = 2; i < ps.length - 4; i += 2) {
      // calculate tension vectors
      t1x = (ps[i + 2] - ps[i - 2]) * tension;
      t2x = (ps[i + 4] - ps[i - 0]) * tension;
      t1y = (ps[i + 3] - ps[i - 1]) * tension;
      t2y = (ps[i + 5] - ps[i + 1]) * tension;
      for (t = 0; t <= numberOfSegments; t++) {
        // calculate step
        st = t / numberOfSegments;
        // calculate cardinals
        c1 = 2 * Math.pow(st, 3) - 3 * Math.pow(st, 2) + 1;
        c2 = -(2 * Math.pow(st, 3)) + 3 * Math.pow(st, 2);
        c3 = Math.pow(st, 3) - 2 * Math.pow(st, 2) + st;
        c4 = Math.pow(st, 3) - Math.pow(st, 2);
        // calculate x and y cords with common control vectors
        x = c1 * ps[i] + c2 * ps[i + 2] + c3 * t1x + c4 * t2x;
        y = c1 * ps[i + 1] + c2 * ps[i + 3] + c3 * t1y + c4 * t2y;
        result.push({ x, y });
      }
    }

    return result;
  }
  drawLines(url, points, x, y, callback) {
    let polygon = new fabric.Polygon(points, {
      strokeWidth: 30,
      stroke: 'white',
      paintFirst: 'stroke',
      backgroundColor: 'rgba(0,0,0,0)',
      fill: 'rgba(0,0,0,0)',
      objectCaching: false,
      transparentCorners: false,
      cornerColor: 'blue',
      selectable: true,
      strokeLineCap: 'round',
      strokeLineJoin: 'round'
    });
    polygon.clipPath = new fabric.Circle({
      radius: 13,
      left: x + 2,
      top: y + 2,
      selectable: !1,
      absolutePositioned: !0,
      crossOrigin: 'anonymous',
      excludeFromExport: true,
      inverted: true
    })

    this.currentCanvas.add(polygon);
    fabric.Image.fromURL(url, (oImg) => {
      this.currentCanvas.add(oImg);
      callback();
    });
  }
  // 通过point 点位坐标,计算出圆滑的连线规则
  drawSmoothCurve(url, points, tension, closed, numberOfSegments, x, y, callback) {
    this.drawLines(
      url,
      this.createSmoothCurvePoints(points, tension, closed, numberOfSegments),
      x, y,
      callback
    );
  }
}

export default DrawUtilFunc;
